<template>
  <footer class="site-footer">
    <!-- Sponsors Section -->
    <section class="sponsors-section">
      <div class="container">
        <h2 class="section-title">
          Empresas, Instituciones y Sponsors que nos han acompañado
        </h2>

        <!-- Tier 1: Main Sponsors (largest) -->
        <div class="sponsors-tier sponsors-tier-1">
          <div class="sponsor-item">
            <a href="https://share.google/ui2hZCY9H1SZfvQWd" target="_blank" rel="noopener" class="sponsor-link" @click="trackClick(1)">
              <img src="/images/sponsors/Panaderia_Parada_11.png" alt="Panaderia Parada 11" class="sponsor-logo">
            </a>
          </div>
          <div class="sponsor-item">
            <a href="https://www.orvent.com.uy/eshop/" target="_blank" rel="noopener" class="sponsor-link" @click="trackClick(2)">
              <img src="/images/sponsors/Montibel.png" alt="Orvent" class="sponsor-logo">
            </a>
          </div>
          <div class="sponsor-item">
            <a href="https://lacisplatina.com/actividades" target="_blank" rel="noopener" class="sponsor-link" @click="trackClick(3)">
              <img src="/images/sponsors/La_Cisplatina_Balnco.png" alt="La Cisplatina" class="sponsor-logo">
            </a>
          </div>
          <div class="sponsor-item">
            <a href="https://www.instagram.com/armeniacocinatipica/?hl=es" target="_blank" rel="noopener" class="sponsor-link" @click="trackClick(4)">
              <img src="/images/sponsors/Logo_Armenia.jpeg" alt="Armenia" class="sponsor-logo">
            </a>
          </div>
        </div>

        <!-- Tier 2: Commercial Sponsors (medium) -->
        <div class="sponsors-tier sponsors-tier-2">
          <div class="sponsor-item">
            <a href="https://delsol.uy/" target="_blank" rel="noopener" class="sponsor-link" @click="trackClick(5)">
              <img src="/images/sponsors/DEl_sol.jpeg" alt="Del Sol" class="sponsor-logo">
            </a>
          </div>
          <div class="sponsor-item">
            <a href="https://www.instagram.com/papeleria.rayuela/?hl=es" target="_blank" rel="noopener" class="sponsor-link" @click="trackClick(6)">
              <img src="/images/sponsors/PAPELERIA_RAYUELA1.png" alt="Papeleria Rayuela" class="sponsor-logo">
            </a>
          </div>
          <div class="sponsor-item">
            <a href="https://gervaso.com/" target="_blank" rel="noopener" class="sponsor-link" @click="trackClick(7)">
              <img src="/images/sponsors/Gervaso.png" alt="Gervaso" class="sponsor-logo">
            </a>
          </div>
          <div class="sponsor-item">
            <a href="https://metropolitano.uy/" target="_blank" rel="noopener" class="sponsor-link" @click="trackClick(8)">
              <img src="/images/sponsors/Metropolitano.png" alt="Metropolitano" class="sponsor-logo">
            </a>
          </div>
        </div>

        <!-- Tier 3: Institutional Sponsors (smaller) -->
        <div class="sponsors-tier sponsors-tier-3">
          <div class="sponsor-item">
            <a href="https://www.gub.uy/ministerio-educacion-cultura/" target="_blank" rel="noopener" class="sponsor-link" @click="trackClick(9)">
              <img src="/images/sponsors/Ministerio_Educacion_Cultura.jpeg" alt="Ministerio de Educación y Cultura" class="sponsor-logo">
            </a>
          </div>
          <div class="sponsor-item">
            <a href="https://www.gub.uy/ministerio-educacion-cultura/cultura" target="_blank" rel="noopener" class="sponsor-link" @click="trackClick(10)">
              <img src="/images/sponsors/Direccion_Nacional_Cultura.jpg" alt="Dirección Nacional de Cultura" class="sponsor-logo">
            </a>
          </div>
          <div class="sponsor-item">
            <a href="https://www.gub.uy/ministerio-educacion-cultura/cultura/inae" target="_blank" rel="noopener" class="sponsor-link" @click="trackClick(11)">
              <img src="/images/sponsors/Instituto_Nacional_ de_Artes_Escenicas.jpg" alt="Instituto Nacional de Artes Escénicas" class="sponsor-logo">
            </a>
          </div>
          <div class="sponsor-item">
            <a href="https://www.ute.com.uy/" target="_blank" rel="noopener" class="sponsor-link" @click="trackClick(12)">
              <img src="/images/sponsors/UTE.jpg" alt="UTE" class="sponsor-logo">
            </a>
          </div>
          <div class="sponsor-item">
            <a href="https://www.instagram.com/municipiociudaddelacosta/" target="_blank" rel="noopener" class="sponsor-link" @click="trackClick(13)">
              <img src="/images/sponsors/Municipio.jpg" alt="Municipio Ciudad de la Costa" class="sponsor-logo">
            </a>
          </div>
          <div class="sponsor-item">
            <a href="https://www.imcanelones.gub.uy/" target="_blank" rel="noopener" class="sponsor-link" @click="trackClick(14)">
              <img src="/images/sponsors/Gobierno_Canelones.jpg" alt="Gobierno de Canelones" class="sponsor-logo">
            </a>
          </div>
          <div class="sponsor-item">
            <a href="https://www.gub.uy/ministerio-ambiente/" target="_blank" rel="noopener" class="sponsor-link" @click="trackClick(15)">
              <img src="/images/sponsors/Dinama.jpg" alt="Dinama" class="sponsor-logo">
            </a>
          </div>
          <div class="sponsor-item">
            <a href="https://uruguaynatural.com/es/" target="_blank" rel="noopener" class="sponsor-link" @click="trackClick(16)">
              <img src="/images/sponsors/Ministerio_turismo.png" alt="Uruguay Natural" class="sponsor-logo">
            </a>
          </div>
        </div>
      </div>
    </section>
  </footer>
</template>

<script>
import { trackSponsorClick } from '@/utils/analytics.js'

export default {
  name: 'SiteFooter',
  methods: {
    trackClick(sponsorId) {
      trackSponsorClick(sponsorId, this.$route.fullPath)
    }
  }
}
</script>

<style scoped>
/* ===== Sponsors Section ===== */
.sponsors-section {
  background: #000;
  padding: 60px 0 80px;
}

.sponsors-section .section-title {
  text-align: center;
  font-size: 24px;
  font-weight: 400;
  letter-spacing: 0.1em;
  margin-bottom: 50px;
  color: #ccc;
  text-transform: uppercase;
}

/* Common tier styles */
.sponsors-tier {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  gap: 30px;
  max-width: 1200px;
  margin: 0 auto 40px;
}

.sponsors-tier:last-child {
  margin-bottom: 0;
}

.sponsor-item {
  flex: 0 0 auto;
}

.sponsor-link {
  display: inline-block;
  line-height: 0;
}

/* Tier 1: Main Sponsors - Large */
.sponsors-tier-1 .sponsor-logo {
  width: 200px;
  height: 100px;
}

/* Tier 2: Commercial Sponsors - Medium */
.sponsors-tier-2 .sponsor-logo {
  width: 140px;
  height: 70px;
}

/* Tier 3: Institutional Sponsors - Small */
.sponsors-tier-3 .sponsor-logo {
  width: 90px;
  height: 45px;
}

.sponsors-tier-3 {
  gap: 20px;
}

/* Actual logo styling - FULL COLOR with hover effects */
.sponsor-logo {
  object-fit: contain;
  transition: all 0.3s ease;
  border-radius: 8px;
}

.sponsor-logo:hover {
  transform: scale(1.2);
  filter: brightness(1.15);
  box-shadow: 0 8px 30px rgba(255, 255, 255, 0.25);
}

/* ===== Mobile Sponsors ===== */
@media (max-width: 992px) {
  .sponsors-section {
    padding: 40px 20px 60px;
  }

  .sponsors-section .section-title {
    font-size: 18px;
    letter-spacing: 0.05em;
    margin-bottom: 30px;
  }

  .sponsors-tier {
    gap: 20px;
    margin-bottom: 30px;
  }

  /* Tier 1: Main Sponsors - Large */
  .sponsors-tier-1 .sponsor-logo {
    width: 160px;
    height: 80px;
  }

  /* Tier 2: Commercial Sponsors - Medium */
  .sponsors-tier-2 .sponsor-logo {
    width: 110px;
    height: 55px;
  }

  /* Tier 3: Institutional Sponsors - Small */
  .sponsors-tier-3 .sponsor-logo {
    width: 70px;
    height: 35px;
  }

  .sponsors-tier-3 {
    gap: 15px;
  }
}

@media (max-width: 576px) {
  .sponsors-tier-1 .sponsor-logo {
    width: 130px;
    height: 65px;
  }

  .sponsors-tier-2 .sponsor-logo {
    width: 90px;
    height: 45px;
  }

  .sponsors-tier-3 .sponsor-logo {
    width: 60px;
    height: 30px;
  }
}
</style>